"use client";

import { delay } from "es-toolkit/promise";
import { useCallback } from "react";
import { useAccount, useChainId, useSwitchChain } from "wagmi";

/**
 * Helper function to require a specific chain, and keep prompting
 */
export function useRequireChain() {
  const activeChainId = useChainId();
  const {
    switchChainAsync
  } = useSwitchChain();
  const {
    connector
  } = useAccount();
  const requireChain = useCallback(async (chainId, tries = 0) => {
    // Special case for Rivet which is only used in E2E tests and does not support switching chains
    if (connector?.id === "et.riv" && activeChainId === chainId) {
      return true;
    }
    const switched = await switchChainAsync({
      chainId
    });
    if (switched.id !== chainId) {
      if (tries >= 3) {
        throw new Error("Failed to switch chain");
      }
      return requireChain(chainId, tries + 1);
    }
    // Remove below delay once issue is fixed from MM side. https://opensea.slack.com/archives/C06UK16LTT4/p1740583203877539?thread_ts=1740580679.909599&cid=C06UK16LTT4
    await delay(400);
    return true;
  }, [activeChainId, connector?.id, switchChainAsync]);
  return {
    requireChain
  };
}